import { useState, useRef, useEffect } from 'react'
import { MoreVertical } from 'lucide-react'

type Props = {
  isBlocked: boolean
  onBlock: () => void
  onUnblock: () => void
}

export function ConversationMenu({ isBlocked, onBlock, onUnblock }: Props) {
  const [open, setOpen] = useState(false)
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open])

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen(!open)}
        className="h-10 w-10 flex items-center justify-center rounded-md hover:bg-accent"
        aria-label="Conversation options"
      >
        <MoreVertical className="h-5 w-5" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 w-44 rounded-md border bg-background shadow-lg z-50">
          {isBlocked ? (
            <button
              onClick={() => {
                setOpen(false)
                onUnblock()
              }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-accent rounded-md"
            >
              Unblock User
            </button>
          ) : (
            <button
              onClick={() => {
                setOpen(false)
                onBlock()
              }}
              className="w-full text-left px-3 py-2 text-sm text-destructive hover:bg-accent rounded-md"
            >
              Block User
            </button>
          )}
        </div>
      )}
    </div>
  )
}
